


























import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
//@ts-ignore
import store from "../../../../store";
import {PlayerState} from "../../../../../types";
import {ChatMessages} from "../../../../../types/chat-messages";

@Component({
    components: {}
})

export default class InvisibleMessage extends Vue {
    @Prop({required: true}) private readonly message!: ChatMessages.Message;

    /**
     * Все игроки
     */
    private get players(): Array<PlayerState>
    {
        return store.getters.getPlayers;
    }

    /**
     * Имя игрока
     * @private
     */
    private get playerName(): string
    {
        return this.gameState.playersData[this.message.playerId].name.toString();
    }

    private get gameState(): any
    {
        return store.getters.getGameState;
    }

    /**
     * Цвет игрока
     * @private
     */
    private get playerColor(): string
    {
        return this.gameState.playersData[this.message.playerId].preferred_color_code.toString();
    }
}
